// Single source of truth for dashboard-aligned day keys & ranges.

export type DayKeysRange = {startKey: string; endKey: string}

// Local YYYY-MM-DD from a Date (local time, midnight-based)
function toLocalDayKeyFromDate(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

// Start of *today* at local midnight
function startOfTodayLocal(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
}

/** Canonical local “yesterday” key (YYYY-MM-DD) */
export function getDashboardYesterdayKey(now: Date = new Date()): string {
  const today = startOfTodayLocal(now)
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  return toLocalDayKeyFromDate(yesterday)
}

/** Inclusive last N local day keys ending on canonical “yesterday” */
export function getDashboardLastNDaysEndingYesterdayKeys(n: number, now: Date = new Date()): DayKeysRange {
  const endKey = getDashboardYesterdayKey(now)
  // Reconstruct a local-midnight Date from the key (avoid UTC parsing)
  const [ey, em, ed] = endKey.split('-').map((s) => parseInt(s, 10))
  const end = new Date(ey, em - 1, ed, 0, 0, 0, 0)

  const days = Math.max(1, n)
  const start = new Date(end)
  start.setDate(end.getDate() - (days - 1))

  return {
    startKey: toLocalDayKeyFromDate(start),
    endKey,
  }
}
